// @ts-nocheck
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackViewItemParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackViewItem";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";
import { useContext } from "react";
import { useSelector } from "react-redux";

const useTrackViewItem = (
    parameters: PartialSpecific<TrackViewItemParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const productId = useContext(ProductContext).product.id;
    const product = useSelector((state: ApplicationState) => getProductState(state, productId).value);

    const hookParameters: TrackViewItemParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        ...options,
        itemData: {
            item_variant: product?.childTraitValues?.map(x => x.valueDisplay).join(ga.constants.separator),
            ...options?.itemData,
        },
    };

    return (parameters: Partial<TrackViewItemParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.viewItem({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackViewItem;
